import { render } from "./Homepage.vue?vue&type=template&id=07d3a634&scoped=true"
import script from "./Homepage.vue?vue&type=script&lang=js"
export * from "./Homepage.vue?vue&type=script&lang=js"

import "../assets/css/homepage.css?vue&type=style&index=0&id=07d3a634&scoped=true&lang=css"

import exportComponent from "/var/www/tz-official-website/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-07d3a634"]])

export default __exports__